var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4995 30C24.4886 30 26.3963 29.2098 27.8028 27.8033C29.2093 26.3968 29.9995 24.4891 29.9995 22.5C29.9995 20.5109 29.2093 18.6032 27.8028 17.1967C26.3963 15.7902 24.4886 15 22.4995 15C20.5104 15 18.6027 15.7902 17.1962 17.1967C15.7897 18.6032 14.9995 20.5109 14.9995 22.5C14.9995 24.4891 15.7897 26.3968 17.1962 27.8033C18.6027 29.2098 20.5104 30 22.4995 30Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 30V15C5.625 12.5136 6.61272 10.129 8.37087 8.37087C10.129 6.61272 12.5136 5.625 15 5.625H30C32.4864 5.625 34.871 6.61272 36.6291 8.37087C38.3873 10.129 39.375 12.5136 39.375 15V30C39.375 32.4864 38.3873 34.871 36.6291 36.6291C34.871 38.3873 32.4864 39.375 30 39.375H15C12.5136 39.375 10.129 38.3873 8.37087 36.6291C6.61272 34.871 5.625 32.4864 5.625 30Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.8125
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.813 12.2051L32.8326 12.1836",
    stroke: "#1E1E1E",
    strokeWidth: 2.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon_instagram.e5636828552174a0703120660876de72.svg";
export { ForwardRef as ReactComponent };